/**
 * File: useTodayBodyController.ts
 * Path: apps/admin/src/features/today/hooks/useTodayBodyController.ts
 * Description: Loads what the Today page adds up for the chosen dates and works out the overview. The money
 * line has its own hook (useTodayMoneyController). With the books, Needs attention lists each overdue invoice too.
 */

import { useMemo } from "react";
import { useInvoiceLedger } from "@/shared/hooks/useInvoiceLedgerQueries";
import { useCrmSettings } from "@/shared/hooks/useCrmSettingsQueries";
import { useNumbersInput } from "@/shared/hooks/useNumbersQueries";
import { buildTodayOverview, loadFrom, type DayRange } from "@/features/today/utils/todayOverviewUtils";

export const useTodayBodyController = (range: DayRange, today: string) => {
  const { settings } = useCrmSettings();
  const { input, failed } = useNumbersInput(loadFrom(range, today), range.from);
  const { ledger } = useInvoiceLedger();
  const books = ledger && ledger !== "unavailable" ? ledger : null;
  const overview = useMemo(() => (input ? buildTodayOverview(input, settings, range, "month", books) : null), [input, settings, range, books]);
  return { failed, overview };
};
